export const cardData = [
  {
    id: 0,
    images: [
      "https://www.deloks.ru/upload/iblock/49f/ttlwkaa6i23boq4hj1oz726f8j4xdvgq/voda_pitevaya_akvanika_premium_negazirovannaya_0_2_l_24_shtuki_v_upakovke_1_full.jpg",
      "https://www.deloks.ru/upload/iblock/cd8/shc165bd4fg8bd0xyl0sou5o0enephx7/voda_pitevaya_akvanika_premium_negazirovannaya_0_2_l_24_shtuki_v_upakovke_4_full.jpg",
      "https://www.deloks.ru/upload/iblock/f8e/zr6deg27wem1rl8t2l8s7sdr9lbx03tu/voda_pitevaya_akvanika_premium_negazirovannaya_0_2_l_24_shtuki_v_upakovke_5_full.jpg",
    ],
    price: 40,
    seller: "Консервный завод Поречский",
    title: 'Вода "Поречская"',
    description:
      "Вода для современных людей, живущих в режиме многозадачности, которым мы предлагаем воду, прошедшую природную фильтрацию, дающую вкус живой природы в городе и переключающую на природное состояние, в котором чувствуешь и фокусируешься на том, что по-настоящему важно. Каждая капля воды Черноголовка негазированная очищается природными фильтрами, многовековыми слоями песка и обогащается полезными минеральными веществами, соотношение которых органично сбалансировано самой природой. И главное, вода Черноголовка такая вкусная, что пить ее легко и приятно!",
    type: "Вода",
    properties: {
      kind: "Питьевая",
      gas: "Негазированная",
      water_source: "Артезианская",
      value: 1500,
      pack: "Пластиковая бутылка",
      unit: 10,
      consist:
        "Основной состав, мг/л: Гидрокарбонаты 130-280; Сульфаты  0,1-10 ; Хлориды 0,1-20; Магний  5-30; Кальций  30-60; Натрий 0,1-20; Калий  0,1-10. Общая минерализация: 0,2 – 0,35 г/л, Общая жесткость : 3,0 – 4,5 мг-экв/л",
    },
  },

  {
    id: 1,
    images: [
      "https://aqualife.ru/upload/iblock/bc5/mogtbxbahn52gci1gzsyxf8sg12cvo3m.png",
      "https://cdn.lentochka.lenta.com/resample/webp/0x0/photo/528136/22c93099-b3eb-41dc-b787-970e2c10a03a.png",
    ],
    price: 80,
    seller: "Завод минеральной воды",
    title: 'Вода "Минеральная" артезианская негазированная бутилированная',
    description:
      "Вода для современных людей, живущих в режиме многозадачности, которым мы предлагаем воду, прошедшую природную фильтрацию, дающую вкус живой природы в городе и переключающую на природное состояние, в котором чувствуешь и фокусируешься на том, что по-настоящему важно. Каждая капля воды Черноголовка негазированная очищается природными фильтрами, многовековыми слоями песка и обогащается полезными минеральными веществами, соотношение которых органично сбалансировано самой природой. И главное, вода Черноголовка такая вкусная, что пить ее легко и приятно!",
    type: "Вода",
    properties: {
      kind: "Питьевая",
      gas: "Негазированная",
      water_source: "Артезианская",
      value: 1500,
      pack: "Пластиковая бутылка",
      unit: 10,
      consist:
        "Основной состав, мг/л: Гидрокарбонаты 130-280; Сульфаты  0,1-10 ; Хлориды 0,1-20; Магний  5-30; Кальций  30-60; Натрий 0,1-20; Калий  0,1-10. Общая минерализация: 0,2 – 0,35 г/л, Общая жесткость : 3,0 – 4,5 мг-экв/л",
    },
  },
  {
    id: 2,
    images: [
      "https://www.deloks.ru/upload/iblock/f8e/zr6deg27wem1rl8t2l8s7sdr9lbx03tu/voda_pitevaya_akvanika_premium_negazirovannaya_0_2_l_24_shtuki_v_upakovke_5_full.jpg",
    ],
    price: 20,
    seller: "Консервный завод Поречский",
    title: 'Вода "Родничок" артезианская негазированная бутилированная',
    description:
      "Вода для современных людей, живущих в режиме многозадачности, которым мы предлагаем воду, прошедшую природную фильтрацию, дающую вкус живой природы в городе и переключающую на природное состояние, в котором чувствуешь и фокусируешься на том, что по-настоящему важно. Каждая капля воды Черноголовка негазированная очищается природными фильтрами, многовековыми слоями песка и обогащается полезными минеральными веществами, соотношение которых органично сбалансировано самой природой. И главное, вода Черноголовка такая вкусная, что пить ее легко и приятно!",
    type: "Вода",
    properties: {
      kind: "Питьевая",
      gas: "Негазированная",
      water_source: "Артезианская",
      value: 1500,
      pack: "Пластиковая бутылка",
      unit: 10,
      consist:
        "Основной состав, мг/л: Гидрокарбонаты 130-280; Сульфаты  0,1-10 ; Хлориды 0,1-20; Магний  5-30; Кальций  30-60; Натрий 0,1-20; Калий  0,1-10. Общая минерализация: 0,2 – 0,35 г/л, Общая жесткость : 3,0 – 4,5 мг-экв/л",
    },
  },

  {
    id: 3,
    images: [
      "https://aqualife.ru/upload/iblock/bc5/mogtbxbahn52gci1gzsyxf8sg12cvo3m.png",
      "https://cdn.lentochka.lenta.com/resample/webp/0x0/photo/528136/22c93099-b3eb-41dc-b787-970e2c10a03a.png",
      "https://www.deloks.ru/upload/iblock/49f/ttlwkaa6i23boq4hj1oz726f8j4xdvgq/voda_pitevaya_akvanika_premium_negazirovannaya_0_2_l_24_shtuki_v_upakovke_1_full.jpg",
      "https://www.deloks.ru/upload/iblock/cd8/shc165bd4fg8bd0xyl0sou5o0enephx7/voda_pitevaya_akvanika_premium_negazirovannaya_0_2_l_24_shtuki_v_upakovke_4_full.jpg",
      "https://www.deloks.ru/upload/iblock/f8e/zr6deg27wem1rl8t2l8s7sdr9lbx03tu/voda_pitevaya_akvanika_premium_negazirovannaya_0_2_l_24_shtuki_v_upakovke_5_full.jpg",
    ],
    price: 57,
    seller:
      "Завод минеральной воды Завод минеральной воды Завод минеральной воды Завод минеральной воды",
    title:
      'Вода "Минеральная" артезианская негазированная бутилированная Вода "Минеральная" артезианская негазированная бутилированнаяВода "Минеральная" артезианская негазированная бутилированнаяВода "Минеральная" артезианская негазированная бутилированнаяВода "Минеральная" артезианская негазированная бутилированнаяВода "Минеральная" артезианская негазированная бутилированнаяВода "Минеральная" артезианская негазированная бутилированная',
    description:
      "Наша вода для современных людей, живущих в режиме многозадачности, которым мы предлагаем воду, прошедшую природную фильтрацию, дающую вкус живой природы в городе и переключающую на природное состояние, в котором чувствуешь и фокусируешься на том, что по-настоящему важно. Каждая капля воды Черноголовка негазированная очищается природными фильтрами, многовековыми слоями песка и обогащается полезными минеральными веществами, соотношение которых органично сбалансировано самой природой. И главное, вода Черноголовка такая вкусная, что пить ее легко и приятно!",
    type: "Вода",
    properties: {
      kind: "ПитьеваяПитьеваяПитьеваяПитьеваяПитьеваяПитьеваяПитьеваяПитьеваяПитьевая",
      gas: "НегазированнаяНегазированнаяНегазированнаяНегазированнаяНегазированнаяНегазированнаяНегазированная",
      water_source:
        "АртезианскаяАртезианскаяАртезианскаяАртезианскаяАртезианскаяАртезианскаяАртезианскаяАртезианская",
      value: "15001500150015001500150015001500",
      pack:
        "Пластиковая бутылкаПластиковая бутылкаПластиковая бутылкаПластиковая бутылка",
      unit: 10000000,
      consist:
        "состав, мг/л: Гидрокарбонаты 130-280; Сульфаты  0,1-10 ; Хлориды 0,1-20; Магний  5-30; Кальций  30-60; Натрий 0,1-20; Калий  0,1-10. Общая минерализация: 0,2 – 0,35 г/л, Общая жесткость : 3,0 – 4,5 мг-экв/л",
    },
  },
  {
    id: 4,
    images: [
      "https://www.deloks.ru/upload/iblock/49f/ttlwkaa6i23boq4hj1oz726f8j4xdvgq/voda_pitevaya_akvanika_premium_negazirovannaya_0_2_l_24_shtuki_v_upakovke_1_full.jpg",
      "https://www.deloks.ru/upload/iblock/cd8/shc165bd4fg8bd0xyl0sou5o0enephx7/voda_pitevaya_akvanika_premium_negazirovannaya_0_2_l_24_shtuki_v_upakovke_4_full.jpg",
      "https://www.deloks.ru/upload/iblock/f8e/zr6deg27wem1rl8t2l8s7sdr9lbx03tu/voda_pitevaya_akvanika_premium_negazirovannaya_0_2_l_24_shtuki_v_upakovke_5_full.jpg",
    ],
    price: 20,
    seller: "Ново-Ярославский нефтеперерабатывающий завод (Славнефть-ЯНОС)",
    title: 'Вода "Родничок" артезианская негазированная бутилированная',
    description:
      "Вода для современных людей, живущих в режиме многозадачности, которым мы предлагаем воду, прошедшую природную фильтрацию, дающую вкус живой природы в городе и переключающую на природное состояние, в котором чувствуешь и фокусируешься на том, что по-настоящему важно. Каждая капля воды Черноголовка негазированная очищается природными фильтрами, многовековыми слоями песка и обогащается полезными минеральными веществами, соотношение которых органично сбалансировано самой природой. И главное, вода Черноголовка такая вкусная, что пить ее легко и приятно!",
    type: "Вода",
    properties: {
      kind: "Питьевая",
      gas: "Негазированная",
      water_source: "Артезианская",
      value: 1500,
      pack: "Пластиковая бутылка",
      unit: 10,
      consist:
        "Основной состав, мг/л: Гидрокарбонаты 130-280; Сульфаты  0,1-10 ; Хлориды 0,1-20; Магний  5-30; Кальций  30-60; Натрий 0,1-20; Калий  0,1-10. Общая минерализация: 0,2 – 0,35 г/л, Общая жесткость : 3,0 – 4,5 мг-экв/л",
    },
  },

  {
    id: 5,
    images: [
        "https://99px.ru/sstorage/53/2017/09/tmb_209272_6897.jpg",
        "https://99px.ru/sstorage/53/2017/09/tmb_209272_6897.jpg",
      ],
    price: 78,
    seller: "Завод минеральной воды",
    title: 'Вода "Минеральная"',
    description:
      "Вода для современных людей, живущих в режиме многозадачности, которым мы предлагаем воду, прошедшую природную фильтрацию, дающую вкус живой природы в городе и переключающую на природное состояние, в котором чувствуешь и фокусируешься на том, что по-настоящему важно. Каждая капля воды Черноголовка негазированная очищается природными фильтрами, многовековыми слоями песка и обогащается полезными минеральными веществами, соотношение которых органично сбалансировано самой природой. И главное, вода Черноголовка такая вкусная, что пить ее легко и приятно!",
    type: "Вода",
    properties: {
      kind: "",
      gas: "",
      water_source: "",
      value: null,
      pack: null,
      unit: null,
      consist: null,
    },
  },
];
